import React from 'react';
import NewMfrLiquidForm from '../components/NewMfrLiquidForm';

const NewMfrLiquidPage: React.FC = () => {
  return (
    <NewMfrLiquidForm
      onSuccess={() => {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/admin/manufacturer_management?activeTab=3`;
      }}
    />
  );
};

export default NewMfrLiquidPage;
